import IconPicker from '../../../scripts/iconpicker-1.5.0.js';

angular.module("cmsCategories")

    .controller("CmsCategoriesEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', '$q', 'logService',
        function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate, $q, logService) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("CMS_CATEGORIES_WRITE");
        $rootScope.title = $filter('translate')('cms_categories.title');
        $scope.cms_categories = {};

        IconPicker.Init({
            // Required: You have to set the path of IconPicker JSON file to "jsonUrl" option. e.g. '/content/plugins/IconPicker/dist/iconpicker-1.5.0.json'
            jsonUrl: '/assets/iconpicker-1.5.0.json',
            // Optional: Change the buttons or search placeholder text according to the language.
            searchPlaceholder: 'Search Icon',
            showAllButton: 'Show All',
            cancelButton: 'Cancel',
            noResultsFound: 'No results found.', // v1.5.0 and the next versions
            borderRadius: '20px', // v1.5.0 and the next versions
        });

        IconPicker.Run('#GetIconPicker', function () {
            // ng-bind no funciona para asignar el icono porque no detecta el cambio que hacemos con el IconPicker, así que hay que hacerlo a pelo.
            let icon = document.querySelector("#IconPreview").getAttribute("class");
            icon = icon.substring(icon.indexOf('-')+1);
            $scope.cms_categories.icon = icon;
      
        });


        $scope.gridArticles = {
            pdfTitle: $filter('translate')('cms_categories.articles'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [10, 20, 30],
            paginationPageSize: 10,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                {
                    name: 'icon', displayName: $filter('translate')('cms.icon'), cellTemplate: '<div class="ui-grid-cell-contents">' +
                        '<i class="fas fa-{{row.entity.icon}} text-primary m-l-sm" ></i>' +
                        '</div>', width: 80, enableFiltering: false, enableHiding: false
                },
                {
                    name: 'title', displayName: $filter('translate')('cms_article.title'), enableFiltering: true, enableHiding: false,
                },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.edit'), action: 'ui-sref="cms_articles.edit({id:row.entity.id, parent_id:row.entity.cms_category_id})"; ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                        { title: $filter('translate')('general.delete'), action: 'ng-click="grid.appScope.deleteArticleDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                }
            ],
            getData: function (options) {

                var deferred = $q.defer();
                options.category_id = $scope.cms_categories.id;

                Restangular.all('CmsArticles').getList(options).then(function (results) {
                    deferred.resolve(results);
                });
                return deferred.promise;
            }
        };

        Restangular.all('CmsCategories').getList().then(function (cms_categories) {
            $scope.selectCmsCategories = cms_categories;
            if (!angular.isUndefined($stateParams.id) && $stateParams.id != "") {
                $scope.selectCmsCategories = $scope.selectCmsCategories.filter(function (x) {
                    return (x.id != $stateParams.id && x.parent_cms_category_id != $stateParams.id);
                })
            }

            logService.debug($scope.selectCmsCategories);
        });

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

            $rootScope.breadcrumb = [
                { title: $filter('translate')('cms_categories.title'), url: "cms_categories.list" },
                { title: $filter('translate')('cms_categories.add') },
            ];
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('cms_categories.title'), url: "cms_categories.list" },
                { title: $filter('translate')('cms_categories.edit') },
            ];

            Restangular.one('CmsCategories', $stateParams.id).get().then(function (results) {
                $scope.cms_categories = results;
                $scope.cms_categories_id = $scope.cms_categories.id;
            });
        }


        $scope.save = function (frmBudgetGroups) {

            if (!angular.isUndefined($scope.cms_categories.id)) {
                $scope.cms_categories.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('cms_categories.modified_success'));
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('CmsCategories').post($scope.cms_categories).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('cms_categories.created_success'));
                        $scope.cms_categories.id = result.id;
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            //Comprobamos si tiene hijos
            let hijos = false;
            $scope.selectCmsCategories.forEach(category => {
                if (category.parent_cms_category_id == $scope.cms_categories.id) { hijos = true };

            });

            if (hijos) {
                modalService.message({
                    title: $filter('translate')('cms_categories.delete_message_children_title'),
                    message: $filter('translate')('cms_categories.delete_message_children_error'),
                    onAccept: function () { }
                });
            } else {
                modalService.confirm({
                    title: $filter('translate')('cms_categories.delete'),
                    message: $filter('translate')('cms_categories.delete_message') + " " + $scope.cms_categories.name + "?",
                    onAccept: function () {
                        $scope.cms_categories.remove().then(function () {
                            toastr.success($filter('translate')('cms_categories.remove_success'));
                            $state.go("cms_categories.list");
                        });
                    }
                });
            }
        };


        $scope.deleteArticleDialog = function (id, title) {
            $scope.id = id;
            $scope.name = title;
            modalService.confirm({
                title: $filter('translate')('cms_articles.delete'),
                message: $filter('translate')('cms_articles.delete_message') + " " + title + "?",
                onAccept: function () {
                    Restangular.one('CmsArticles', id).remove().then(function () {
                        toastr.success($filter('translate')('cms_articles.remove_success'));
                        $scope.gridArticles.data =
                            $scope.gridArticles.data.filter(function (el) { return el.id != $scope.id; });
                    }, function (response) {
                        logService.error("Error with status code", response.status);
                    });
                }
            });

        };

    }])

    ;

